const initState = {
  panel: null,
}

export default function (state = initState, action) {
  switch (action.type) {
    case 'PANEL':
      return {
        ...state,
        panel: action.payload,
      }
    default:
      return state
  }
}
